// extracted by mini-css-extract-plugin
module.exports = {"toggleDiv":"LoginRegisterXS_toggleDiv__17y2Y","toggleButton":"LoginRegisterXS_toggleButton__34Awd"};